import React from "react";
import { Stack, Typography } from "@mui/material";

import { formatDateMmDdYyyy } from "../../helpers/dateHelper";
import { StyledGridStack } from "./styles";

const Details = ({ label, spanishLabel, value, ...rest }) => (
  <Stack {...rest} gap="5px">
    <Stack direction="row" gap="5px">
      <Typography variant="boldCaptionMainL">{label}</Typography>
      <Typography variant="boldCaption">({spanishLabel})</Typography>
    </Stack>
    <Typography
      variant="caption"
      sx={{
        fontWeight: 600,
        fontSize: 12,
        backgroundColor: "hubColors.mainFocusLighter2",
        padding: "5px 10px",
        borderRadius: "5px",
      }}
    >
      {value}
    </Typography>
  </Stack>
);

const LaborDetails = ({ data }) => {
  const plannedStart = new Date(data?.routing?.plannedStartDate);
  const plannedEnd = new Date(data?.routing?.plannedEndDate);
  const workOrder = data?.workOrder;

  return (
    <StyledGridStack>
      <Details
        label="Employee"
        spanishLabel="Empleado"
        value={data?.user?.name}
      />
      <Details
        label="Station"
        spanishLabel="Estación"
        value={data?.station?.label}
      />
      <Details
        label="Planned Start/Due Date"
        spanishLabel="Fecha de Inicio/Entrega Planificada"
        value={`${formatDateMmDdYyyy(plannedStart)} - ${formatDateMmDdYyyy(
          plannedEnd
        )}`}
        sx={{ gridColumn: "span 2" }}
      />
      <Details
        label="Quantity"
        spanishLabel="Cantidad"
        value={workOrder?.quantity}
      />
      <Details
        label="Work Order"
        spanishLabel="Orden de Trabajo"
        value={workOrder?.workOrder}
      />
      <Details
        label="Part"
        spanishLabel="Parte"
        value={workOrder?.part?.partName}
      />
      <Details
        label="Parts Per Tree"
        spanishLabel="Piezas por Árbol"
        value={workOrder?.part?.partsPerTree}
      />
      <Details label="Trees" spanishLabel="Árboles" value={workOrder?.trees} />
      <Details
        label="Route Completed"
        spanishLabel="Ruta Terminado"
        value={data?.routing?.completed}
      />
      <Details
        label="Total Scrapped"
        spanishLabel="Total Rechazado"
        value={data?.totalScrapped}
      />
      <Details
        label="Available"
        spanishLabel="Disponible"
        value={data?.available}
      />
    </StyledGridStack>
  );
};

export default LaborDetails;
